<template>
    <div>

        <headline>
            Etagen

            <template v-slot:more>
                <floor-create @created="load"></floor-create>
            </template>
        </headline>

        <tailwind-table :header="['Etage', 'Karte', 'Anzahl Räume', '']">
            <tr v-for="(floor, i) in floors" :key="floor.id" :class="{'bg-white': i % 2}">
                <td class="px-6 py-2">
                    <floor-item :item="floor"></floor-item>
                </td>
                <td class="px-6 py-2">
                    {{ floor.map_link ? 'Ja' : 'Keine Karte' }}
                </td>
                <td class="px-6 py-2">
                    {{ floor.rooms_count }}
                </td>
                <td class="px-6 py-2">
                    <a :href="`/admin/pages/floors/${floor.id}`">
                    <button-white>
                        <i class="fa fa-mr-2"></i> Anzeigen
                    </button-white>
                    </a>
                    <!--<floor-edit :id="floor.id" @reload="load"></floor-edit>-->
                </td>
            </tr>
        </tailwind-table>

    </div>
</template>

<script>

import Headline from "../components/UI/Headline";
import TailwindTable from "../components/UI/TailwindTable";
import FloorEdit from "../components/FloorEdit";
import Popup from "../components/Popup";
import ButtonWhite from "../components/UI/ButtonWhite";
import FloorCreate from "../components/FloorCreate";
import FloorItem from "../components/FloorItem.vue";

export default {
    name: "Floors",
    components: {FloorItem, FloorCreate, ButtonWhite, Popup, FloorEdit, TailwindTable, Headline,},
    data: () => ({
        floors: [],
        loading: false,
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            window.axios.get('/admin/floors').then((response) => {
                this.floors = response.data.data;
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped>

</style>
